import { render, staticRenderFns } from "./UPhoneInput.vue?vue&type=template&id=b93bec1a&scoped=true"
import script from "./UPhoneInput.vue?vue&type=script&lang=js"
export * from "./UPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93bec1a",
  null
  
)

export default component.exports